import { combineReducers } from "redux";

// Authentication
import Login from "./auth/reducer";
import Users from "./users/reducer";
import Groups from "./groups/reducer";
import Releases from "./releases/reducer";
import ReleaseNotes from "./releaseNotes/reducer";
import Notifications from "./notifications/reducer";
import Parameters from "./parameters/reducer";
import Comments from "./comments/reducer";
import Projects from "./projects/reducer";
import Products from "./products/reducer";
import Brands from "./brands/reducer";
import Components from "./components/reducer";
import Categories from "./categories/reducer";
import Documents from "./documents/reducer";
import Configurations from "./configurations/reducer";
import Sectors from "./sectors/reducer";
import Agencies from "./agencies/reducer";
import Departments from "./departments/reducer";
import Lines from "./lines/reducer";
import Quotes from "./quotes/reducer";
import Dashboard from "./dashboard/reducer";


const appReducer = combineReducers({
  // public
  Login,
  Users,
  Groups,
  Releases,
  ReleaseNotes,
  Notifications,
  Parameters,
  Comments,
  Projects,
  Products,
  Brands,
  Components,
  Categories,
  Documents,
  Configurations,
  Sectors,
  Agencies,
  Departments,
  Lines,
  Quotes,
  Dashboard,
});

// Root reducer with reset capability
const rootReducer = (state, action) => {
  // Clear state on logout
  if (action.type === 'LOGOUT_USER') {
    // This will reset redux state but keep persist config
    return appReducer(undefined, action);
  }
  
  return appReducer(state, action);
};

export default rootReducer;